import { render, staticRenderFns } from "./OwnershipConflictList.vue?vue&type=template&id=3229f73c&scoped=true&"
import script from "./OwnershipConflictList.vue?vue&type=script&lang=js&"
export * from "./OwnershipConflictList.vue?vue&type=script&lang=js&"
import style0 from "./OwnershipConflictList.vue?vue&type=style&index=0&id=3229f73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3229f73c",
  null
  
)

export default component.exports